import React from 'react';
import { Box, InputBase, Typography } from '@material-ui/core';
import { Add, Search as SearchIcon } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

interface BulletinsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  onAddBulletin?: () => void;
}

export const BulletinsToolbar = ({ search, onSearchChange, onAddBulletin }: BulletinsToolbarProps) => {
  const { isMobile, isSm } = useCampfireTheme();

  return (
    <Box
      flexShrink={0}
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      padding='16px 28px'
      style={{ gap: 24, borderBottom: '1px solid #EFEFEF' }}
    >
      {!isMobile && !isSm && (
        <Box minWidth={0}>
          <Typography style={{ fontSize: '14px', fontWeight: 700, color: '#333' }}>Bulletins</Typography>
          <Typography noWrap style={{ fontSize: 13, color: '#646464', marginTop: 2 }}>
            Announcements, updates and other information recorded for your whole volunteer base.
          </Typography>
        </Box>
      )}

      <Box display='flex' alignItems='center' flexShrink={0} style={{ gap: 8 }}>
        <Box
          display='flex'
          alignItems='center'
          width={260}
          height={32}
          paddingX='12px'
          style={{ border: '1px solid #d9d9d9', borderRadius: 4, boxSizing: 'border-box' }}
        >
          <SearchIcon style={{ fontSize: 16, color: '#646464', flexShrink: 0, marginRight: 8 }} />
          <InputBase
            value={search}
            placeholder='Search bulletins'
            onChange={(event) => onSearchChange(event.target.value)}
            style={{ flexGrow: 1, fontSize: 13, color: '#444444' }}
          />
        </Box>
        {onAddBulletin && (
          <TabletButton
            variant='contained'
            color='primary'
            onClick={onAddBulletin}
            startIcon={<Add style={{ fontSize: 16 }} />}
            style={{ borderRadius: 4, textTransform: 'none', padding: '6px 12px', whiteSpace: 'nowrap' }}
          >
            Add bulletin
          </TabletButton>
        )}
      </Box>
    </Box>
  );
};
